import React from "react";

export const Banner = () => {
  return (
    <section id="banner">
      <div className="container">
        <div className="banner-showcase-image">
          <img src="/images/banner.jpg" alt="" className="banner-image" />
        </div>
      </div>
    </section>
  );
};
